import { useCallback, useRef, useState } from 'react';
import { styled } from '@mui/material/styles';

import Tooltip from '../Tooltip';
import { EllipsisWithTooltipProps } from './types';

const EllipsisWithTooltip = ({
  children,
  tooltipContent,
}: EllipsisWithTooltipProps): JSX.Element => {
  const ellipsisElementRef = useRef<HTMLDivElement>(null);

  const [isEllipsized, setIsEllipsized] = useState(false);

  const handleMouseOver = useCallback(() => {
    setIsEllipsized(
      (ellipsisElementRef.current?.scrollWidth || 0) >
        (ellipsisElementRef.current?.clientWidth || 0),
    );
  }, []);

  return (
    <Tooltip
      // Default Tooltip styles prevent ellipsis from working, reset them:
      sx={{ display: 'initial', width: 'initial' }}
      tooltipContent={isEllipsized ? (tooltipContent ?? children ?? <></>) : ''}
    >
      <Ellipsis ref={ellipsisElementRef} onMouseOver={handleMouseOver}>
        {children}
      </Ellipsis>
    </Tooltip>
  );
};

const Ellipsis = styled('div')`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export default EllipsisWithTooltip;
